import { Avatar, Container, Grid } from "@mui/material";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { useState } from "react";
import { Box } from "@mui/system";
import Money from "./Money";
import Order from "./Order";



function stringAvatar(name) {
    return {
      sx: {
        bgcolor: "#42a5f5",
        height: "24px",
        width: "24px",
        fontSize: "12px"
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

function Index({logOut, userID}){
    
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [type, setType] = useState("order");

    return (
        <div className={'body'}>

            <AppBar style={{marginBottom: "20px"}} position="static">
                <Container>
                    <Toolbar>
                    <Typography display={{ xs: "none", lg: "block" }} variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Afrodita Kozmetika - Szeminárium termék-, és árlista
                    </Typography>

                    <Typography display={{ xs: "block", lg: "none" }} variant="h8" component="div" sx={{ flexGrow: 1 }}>
                        Afrodita Kozmetika <br/>Szeminárium termék-, és árlista
                    </Typography>
                        
                        <div>
                            <Button
                                id="basic-button"
                                aria-controls="basic-menu"
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                                variant="text"
                            >
                                <Avatar 
                                    sx={{ width: 24, height: 24, mr: "10px" }} {...stringAvatar(userID.name)}
                                    style={{cursor: "pointer"}}
                                />
                                <Box sx={{ ml: "10px", display: { xs: 'none', sm: 'block' } }} style={{color: "#fff", fontWeight: "bold"}}>{userID.name}</Box>

                            </Button>
                            
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                }}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                      overflow: 'visible',
                                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                      mt: 1.5,
                                      '& .MuiAvatar-root': {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                      },
                                      '&:before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                      },
                                    },
                                  }}
                            >
                                <MenuItem onClick={() => logOut()}><FontAwesomeIcon icon={faSignOutAlt} style={{marginRight: "10px"}}/>Kijelentkezés</MenuItem>
                            </Menu>
                        </div>
                    </Toolbar>
                </Container>
            </AppBar>
            <div className={'content'}>
                <Container>
                    <Grid container spacing={2} style={{marginBottom: "20px"}}>
                        <Grid item xs={12} md={6}>
                            <Button onClick={() => setType("money")} fullWidth variant = {type === "money" ? "contained" : "outlined"}>Helyszíni vásárlás</Button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Button onClick={() => setType("order")} fullWidth variant = {type === "order" ? "contained" : "outlined"}>Megrendelés</Button>
                        </Grid>
                    </Grid>

                    {type === "money" ? <Money userID={userID}/> : <Order userID={userID}/>}
                </Container>
            </div>
        </div> 
    )
}

export default Index;